var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitsAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 28.998H5.3335C5.3335 24.2961 8.81044 20.4062 13.3335 19.7592M26.497 21.2698C26.406 21.2752 26.3145 21.278 26.2224 21.278C24.8564 21.278 23.6104 20.668 22.6668 19.6647C21.7232 20.6679 20.4772 21.2779 19.1113 21.2779C19.0192 21.2779 18.9276 21.2752 18.8367 21.2697C18.7258 21.7785 18.6668 22.312 18.6668 22.862C18.6668 25.8141 20.3665 28.2947 22.6668 28.998C24.9671 28.2947 26.6668 25.8141 26.6668 22.862C26.6668 22.312 26.6079 21.7785 26.497 21.2698ZM20.0002 10.3314C20.0002 13.2769 17.6123 15.6647 14.6668 15.6647C11.7213 15.6647 9.3335 13.2769 9.3335 10.3314C9.3335 7.38586 11.7213 4.99805 14.6668 4.99805C17.6123 4.99805 20.0002 7.38586 20.0002 10.3314Z",
    stroke: "#D6D8E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsAudit);
export default __webpack_public_path__ + "static/media/benefitsAudit.1dfd1e6d26c7d3489a9dae7c1a4d35ab.svg";
export { ForwardRef as ReactComponent };